export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.25-1011.46",
  commitId: "7acc1dbe1311b37af326efb1a56817df10673937",
  commitTime: "2026-09-25T10:11:46.000Z",
});
